import React from 'react'
import { Button } from '@shopify/polaris'

const EditIconButton = ({ onClick }) => {
	return (
		<Button
			variant={'plain'}
			onClick={onClick}
		>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M16.2929 7.29289L16.7071 7.70711L16 8.41421L7.70711 16.7071L6.29289 18.1213L5.5 20.5L8.5 19.5L20.5 7.5L19.5 5.5L16.2929 7.29289Z'
					stroke='black'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		</Button>
	)
}

export default EditIconButton

